var isDisabled=props=>props.disabled||Array.isArray(props.accessibilityStates)&&props.accessibilityStates.indexOf("disabled")>-1;export default isDisabled;